export enum ModelType {
    DIMENSION = "Dimension",
    ISSUE = "Issue",
    LOCATION = "Location",
    WORK_SPECIFICATION = "WorkSpecification",
    PROPOSAL_ITEM = "ProposalItem"
}
